// extracted by mini-css-extract-plugin
module.exports = {"albumCover":"Album-module--albumCover--3taJo","albumName":"Album-module--albumName--3Z05K"};